const ajax = require('sma.common/ajax');
const Grid = require('sma.admin/components/grid');
const Dropdown =  require('sma.admin/components/dropdowns/dropdown');
const modals = require('sma.common/components/modals');
const TextEditor = require('sma.common/texteditor');

const userTempl = require('sma.applicant/organizations/partials/user.mustache');
const teamTempl = require('sma.applicant/organizations/partials/team.mustache');

let sendEmail = (grid, id=null) => {
	let ids = id !== null ? [id] : grid.selectedIds;

	if (ids.length === 0) {
		grid.nothingSelected();
		return;
	}

	let emailModal = new modals.AjaxFormModal({
		size: 'md',
		destroyOnClose: true,
		autoShow: true,
		onSuccess: (modal) => {
			emailModal.hide();
			grid.load();
		}
	});

	let emailContent = new modals.AjaxFormContent(
		reverse('org-teams-email') + '?' + $.param({ids}), 
		{
			buttons: [{
				label: gettext('CANCEL'),
				cls: 'btn-secondary',
				handler: (modal) => {
					modal.hide();
				}
			}, {
				label: gettext('OK'),
				cls: 'btn-primary',
				handler: (modal) => {
					modal.modalBody.find('form').submit();
				}
			}],
			onLoad: () => {
				new TextEditor({
					textarea: $('textarea.sma-text-editor'),
					piping: null
				});
			}
		}
	);

	emailModal.addToStack('Email', emailContent);
};

let deleteTeam = (grid, ids) => {
	new modals.CheckboxModal(
		gettext('Delete team'),
		gettext('Are you sure you want to remove the selected teams?'),
		gettext('Also remove members from your organization'),
		(removeMembers) => {
			let data = {
				ids: ids,
				members: removeMembers
			};

			ajax.post({
				url: reverse('org-teams-remove'),
				data: data,
				callback: (response) => { grid.load(); }
			});
		}
	);
};

let renameTeam = (grid, id) => {
	new modals.Prompt(
		gettext('Rename team'),
		gettext('Enter a new name for your team'),
		(name) => {
			ajax.post({
				url: reverse('org-teams-rename'),
				data: {id, name},
				callback: () => {
					grid.load();
				}
			})
		}, {}
	);
};

let createTeam = (grid) => {
	new modals.Prompt(
		gettext('Create team'),
		gettext('Enter a name for the new team'),
		(name) => {
			ajax.post({
				url: reverse('org-teams-create'),
				data: {name},
				callback: () => {
					grid.load();
				}
			});
		}
	);
};

let openTeamPanel = (grid, team_id) => {
	ajax.get({
		url: reverse('org-teams-panel', {team_id}),
		callback: (response) => {
			renderTeamMemberGrid(response.panel_html, response.results, team_id, grid);
		}
	});
};

let renderTeamMemberGrid = (template, results, team_id, parent_grid) => {
	const tableElement = $('.sma-js-table-left');

	$('.sma-js-table-right').remove();
	tableElement.removeClass('col-sm-12').addClass('col-sm-7');
	tableElement.after($(template));

	$('.sma-js-close-team-detail-panel').on('click', () => {
		$('.sma-js-table-right').remove();
		tableElement.removeClass('col-sm-7').addClass('col-sm-12');
	});

	new Grid.Grid({
		element: $('.sma-js-team-memberships'),
		results: results,
		showSelectorColumn: false,
		showSearchBar: false,
		showFooter: false,
		showColumnDropSelect: false,
		showTitlebar: false,
		columns: [
			{
				id: 'name', 
				name: gettext('Team member'),
				formatter: (item) => {
					return userTempl({
						initials: item.initials,
						name: item.name,
						email: item.email
					});
				}
			}
		],
		extraToolbarItems: (grid) => {
			return [
				{
					trigger: 'click',
					html: '<button class="btn btn-default sma-js-remove-members">'+gettext('Remove')+'</button>',
					action: (data) => {
						removeMembers(grid, data.ids, team_id, parent_grid);
					}
				}, {
					trigger: 'click',
					html: '<button class="btn btn-default">'+gettext('Add members')+'</button>',
					action: (data) => {
						addMembers(grid, team_id, parent_grid);
					}
				}
			];
		},
		updateTallyCallback: (grid) => {
			$('.sma-js-remove-members').attr('disabled', function(a,b) {
				return grid.numSelected === 0
			});
		}
	});
};

let removeMembers = (grid, ids, team_id, parent_grid) => {
	new modals.Confirm(
		gettext('Remove from team'),
		gettext('Are you sure you want to remove the \
		selected members from this team?'),
		() => {
			ajax.post({
				url: reverse('org-teams-members-remove', {team_id}),
				data: {ids},
				callback: (response) => {
					grid.results = response.results;
					grid.load();
					parent_grid.load();
				}
			});
		}
	);
};

let addMembers = (grid, team_id, parent_grid) => {
	let gridElem = $('<div class="sma-js-team-org-members-grid"></div>');

	let memberGrid = new Grid.Grid({
		element: gridElem,
		results: {results: []},
		showFooter: false,
		showTitlebar: false,
		showToolbar: true,
		showColumnDropSelect: false,
		url: reverse('org-teams-members-data', {team_id}),
		columns: [{
			id: 'name',
			name: gettext('Name'),
			formatter: (item) => {
				return userTempl({
					initials: item.initials,
					name: item.name,
				});
			}
		}, {
			id: 'email',
			name: gettext('Email')
		}]
	});

	memberGrid.load();
	
	new modals.ContentModal(gridElem, {
		autoShow: true,
		destroyOnClose: true,
		title: gettext('Add members'),
		buttons: [{
			label: gettext('CANCEL'),
			cls: 'btn btn-link',
			handler: (modal) => {
				modal.hide();
			}
		}, {
			label: gettext('ADD'),
			cls: 'btn btn-primary',
			handler: (modal) => {
				let ids = memberGrid.selectedIds;
				new ajax.post({
					url: reverse('org-teams-members-data', {team_id}),
					data: {ids},
					callback: (response) => {
						grid.results = response.results;
						grid.load();
						parent_grid.load();
					}
				});
				modal.hide();
			}
		}],
	});
};

let OrganizationTeamsGrid = Grid.Grid.extend({
	gridLabel: gettext('member'),
	orderCols: ['name', 'email', 'last_login', 'invited_at', 'signup_date', 'active', 'role'],
	columns: [
		{
			id: 'name',
			name: gettext('Name'),
			formatter(item, grid) {
				return teamTempl({
					id: item.id,
					name: item.name
				});
			}
		}, {
			id: 'num_members',
			name: gettext('# of members'),
		}, {
			name: '',
			id: 'actions',
			alwaysDisplayed: true,
			formatter: (item, grid) => {
				if (item.is_primary_admin) return;

				return new Dropdown({
					className: 'pull-xs-right btn-group sma-hideable-menu',
					type: 'heading',
					noCaret: true,
					title: '<i class="nc-icon-mini ui-2_menu-dots"></i>',
					rightAligned: true,
					items: $.grep([
						item.num_members ? {
							name: 'email',
							text: gettext('Email'),
							action: (args) => {
								sendEmail(grid, item.id);
							}						
						} : null, {
							name: 'team_membership',
							text: gettext('Edit team members'),
							action: (args) => {
								openTeamPanel(grid, item.id);
							}
						}, item.is_active ? null : {
							name: 'rename',
							text: gettext('Rename'),
							action: (args) => {
								renameTeam(grid, item.id);
							}
						}, {
							name: 'delete',
							text: gettext('Delete team'),
							action: (args) => {
								deleteTeam(grid, [item.id]);
							}
						}
					], (x) => x != null),
					addActionData: () => ({ grid })
				}).$el;
			},		
		}
	],
	actions: [
		{
			name: 'delete',
			text: gettext('Delete team'),
			action: (args) => {
				deleteTeam(args.grid, args.ids);
			}
		}
	],
	extraToolbarItems: (grid) => {
		return [
			{
				trigger: 'click',
				html: '<button class="btn btn-default"><i class="nc-icon-mini ui-1_email-83"></i></button>',
				action: (data) => {
					sendEmail(grid);
				}
			}, {
				trigger: 'click',
				html: '<button class="btn btn-default">'+gettext('Create team')+'</button>',
				action: (data) => {
					createTeam(grid);
				}
			}
		];
	},
	onLoad: (grid, results) => {
		$('.sma-js-team-link').on('click', (e) => {
			let team_id = $(e.currentTarget).data('id');
			openTeamPanel(grid, team_id);
		});
	}
});

module.exports = {
	OrganizationTeamsGrid
}
